import { IconLabelState } from 'sierra-client/views/course-helper/shared/shared'
import { TextState } from 'sierra-client/views/course-helper/types'

export const TextComponent: React.FC<{ textState: TextState }> = ({ textState }) => {
  return <IconLabelState iconId={textState.iconId} title={textState.text} onClick={textState.onClick} />
}
